/**
 * GraphQL `JSON` scalars often arrive as parsed objects. Tier helpers and Redux expect a JSON string.
 */
export function merchantMetadataToJsonString(value: unknown): string | undefined {
  if (value === undefined || value === null) return undefined;
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return undefined;
    }
  }
  if (typeof value === 'number') {
    return String(value);
  }
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }
  if (typeof value === 'bigint') {
    return value.toString();
  }
  return undefined;
}

export function extractFollowersTierFromMetadata(value: string): number | undefined {
  const metadata = JSON.parse(value);
  const tier = metadata.tts_tier_record?.tier;
  if (!tier) return undefined;
  if (tier.creator_follower_count === 'N/A') {
    return 0;
  }
  if (tier.creator_follower_count === 'Unlimited') {
    return Infinity;
  }
  return Number.parseInt(tier.creator_follower_count.replace('Up to ', '').replace(',', ''));
}

export function extractOutreachTierRestrictionFromMetadata(value: string): boolean | undefined {
  const metadata = JSON.parse(value);
  const tier = metadata.tts_tier_record?.tier;
  if (!tier) return undefined;
  return tier.unconnected_creators !== 'Unlimited';
}

export function extractUnconnectedCreatorsTierRestriction(value: string): number | undefined {
  const metadata = JSON.parse(value);
  const tier = metadata.tts_tier_record?.tier;
  if (!tier) return undefined;
  if (tier.unconnected_creators === 'Unlimited') {
    return Infinity;
  }
  return Number.parseInt(tier.unconnected_creators.replace('Up to ', '').replace(',', ''));
}

export function extractStarterTier(value: string): boolean {
  const metadata = JSON.parse(value);
  if (metadata.tts_tier_record?.tier && metadata.tts_tier_record?.tier?.gmv === 'Starter') {
    return true;
  }
  return false;
}
